import React from "react";

// router
import { Switch, Route, Redirect } from "react-router-dom";

// components
import Home from "components/Home";
import Categories from "components/Categories";
import Shop from "components/Shop";
import Product from "components/ProductDetail";
import Cart from "components/Cart";
import Checkout from "components/Checkout";
import Login from "components/Login";
import Register from "components/Register";
import OrderSucess from "components/Cart/themes/Theme1/Pages/OrderSucess";

// my account
import MyAccount from 'components/MyAccount'
import AccountSettings from 'components/MyAccount/Pages/AccountSettings'
import Addresses from 'components/MyAccount/Pages/Addresses'
import Orders from 'components/MyAccount/Pages/Orders'
import OrdersDetails from 'components/MyAccount/Pages/OrdersDetails'

// content
import Content from 'components/Content'

// contact us
import ContactUs from 'components/ContactUs'
import AboutUs from 'components/AboutUs'

// reset password
import ResetPassword from "components/ResetPassword";


// protected routes
import ProtectedRoute from "./ProtectedRoute";

// scroll to top
import ScrollToTop from "./ScrollToTop";

// complete payment
import CompletePayment from "components/CompletePayment";

export default function AllRoutes(props) {
	// props
	const { authLoading } = props

	return (
		<React.Fragment>
			{/* SCROLL TO TOP WHEN ROUTE CHANGES */}
			<ScrollToTop />

			<Switch>
				{/* all components */}
				<Route path="/" component={Home} exact />
				<Route path="/home" component={Home} />
				<Route
					path="/category/:catName"
					component={Categories}
				/>
				<Route
					path="/shop/:catName"
					component={Shop}
				/>
				<Route
					path="/product/:prodName"
					component={Product}
				/>
				<Route
					path="/cart"
					component={Cart}
				/>

				<Route
					path="/cart-success"
					component={OrderSucess}
				/>
				<Route
					path="/login"
					component={Login}
				/>
				<Route
					path="/register"
					component={Register}
				/>

				<Route
					path="/checkout"
					component={Checkout}
				/>

				<Route
					path="/reset/password/:userId/:userToken"
					component={ResetPassword}
				/>

				<Route
					path="/order-payment/:orderId/:orderToken"
					component={CompletePayment}
				/>

				<Route
					path="/content/:pageName"
					component={Content}
				/>

				<Route
					path="/contact-us"
					component={ContactUs}
				/>
				<Route
					path="/about-us"
					component={AboutUs}
				/>

				{/* my account */}
				<ProtectedRoute
					authLoading={authLoading}
					path="/account/account-settings/:type"
					component={AccountSettings}
				/>
				<ProtectedRoute
					authLoading={authLoading}
					path="/account/"
					component={Orders}
					exact>
					<Redirect to="/account/account-settings/personal-details" />
				</ProtectedRoute>

				<ProtectedRoute
					authLoading={authLoading}
					path="/account/address/:addressType"
					component={Addresses}
				/>

				<ProtectedRoute
					authLoading={authLoading}
					path="/account/orders/:orderType"
					component={Orders}
					exact
				/>
				<ProtectedRoute
					authLoading={authLoading}
					path="/account/orders/"
					component={Orders}
					exact>
					<Redirect to="/account/orders/all-orders" />
				</ProtectedRoute>

				<ProtectedRoute
					authLoading={authLoading}
					path="/account/orders/details/:orderId"
					component={OrdersDetails}
				/>

				<Route path="**" component={Home} />

			</Switch>
		</React.Fragment>
	);
}
